import { Progress } from '@discretize/gw2-ui-new'
import {
  Skills,
  Weapons,
  TextDivider,
  iconSizes,
} from '@discretize/react-discretize-components'
import Error from '@mui/icons-material/Error'
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material'
import axios from 'axios'
import { StaticImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import Context from '../../state/context/ProfessionContext'
import Embed from '../Embed'
import EmbossedCard from '../EmbossedCard'
import { Item } from '../gw2components'
import Legends from '../gw2components/Legends'
import Label from '../Label'
import Link from '../navigation/Link'

const useStyles = makeStyles()((theme) => ({
  root: {
    color: theme.palette.text.primary,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: iconSizes.large,
    marginRight: theme.spacing(2),
  },
  text: {
    '& > *:last-child': {
      marginBottom: 0,
    },
  },
  image: {
    width: '100%',
    height: '100%',
  },
  errorMsg: {
    paddingLeft: '5px',
  },
  row: {
    '@media (max-width: 780px)': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  card: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),

    '@media (max-width: 760px)': {
      padding: '20px 0',
    },
  },
  video: {
    paddingBottom: '0px !important',
  },
  legends: {
    padding: theme.spacing(1),
  },
  weaponWrapper: {
    '@media (max-width: 780px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  errorMsgWrap: {
    display: 'flex',
    alignItems: 'center',
  },
}))

export const BOSSES = [
  {
    name: 'MAMA',
    hp: '5,200,519',
    fractal: 'Nightmare',
    id: 17021,
    Image: () => (
      <StaticImage
        src="../../assets/images/bosses/mama.jpg"
        alt="Picture of fractal boss M.A.M.A."
        aspectRatio={16 / 10}
        transformOptions={{ cropFocus: 'center' }}
      />
    ),
  },
  {
    name: 'Siax',
    hp: '6,138,797',
    fractal: 'Nightmare',
    id: 17028,
    Image: () => (
      <StaticImage
        src="../../assets/images/bosses/siax.jpg"
        alt="Picture of fractal boss Siax"
        aspectRatio={16 / 10}
        transformOptions={{ cropFocus: 'center' }}
      />
    ),
  },
  {
    name: 'Ensolyss',
    hp: '14,059,890',
    fractal: 'Nightmare',
    id: 16948,
    Image: () => (
      <StaticImage
        src="../../assets/images/bosses/enso.jpg"
        alt="Picture of fractal boss Ensolyss"
        aspectRatio={16 / 10}
        transformOptions={{ cropFocus: 'center' }}
      />
    ),
  },
  {
    name: 'Skorvald',
    hp: '5,551,340',
    fractal: 'Shattered-Observatory',
    id: 17632,
    Image: () => (
      <StaticImage
        src="../../assets/images/bosses/skorvald.png"
        alt="Picture of fractal boss Skorvald"
        aspectRatio={16 / 10}
        transformOptions={{ cropFocus: 'center' }}
      />
    ),
  },
  {
    name: 'Artsariiv',
    hp: '5,962,266',
    fractal: 'Shattered-Observatory',
    id: 17949,
    Image: () => (
      <StaticImage
        src="../../assets/images/bosses/artsariiv.jpg"
        alt="Picture of fractal boss Artsariiv"
        aspectRatio={16 / 10}
        transformOptions={{ cropFocus: 'center' }}
      />
    ),
  },
  {
    name: 'Arkk',
    hp: '9,942,250',
    fractal: 'Shattered-Observatory',
    id: 17759,
    Image: () => (
      <StaticImage
        src="../../assets/images/bosses/arkk.jpg"
        alt="Picture of fractal boss Arkk"
        aspectRatio={16 / 10}
        transformOptions={{ cropFocus: 'center' }}
      />
    ),
  },
  {
    name: 'LightAi',
    hp: '15,000,000',
    fractal: 'Sunqua-Peak',
    id: 232543,
    Image: () => (
      <StaticImage
        src="../../assets/images/bosses/lightai.jpg"
        alt="Picture of fractal boss Light Ai "
        aspectRatio={16 / 10}
        transformOptions={{ cropFocus: 'center' }}
      />
    ),
  },
  {
    name: 'DarkAi',
    hp: '15,000,000',
    fractal: 'Sunqua-Peak',
    id: 232542,
    Image: () => (
      <StaticImage
        src="../../assets/images/bosses/darkai.jpg"
        alt="Picture of fractal boss Dark Ai "
        aspectRatio={16 / 10}
        transformOptions={{ cropFocus: 'center' }}
      />
    ),
  },
]

function Boss({
  video,
  videoCreator,
  timestamp,
  name,
  hideRotation,
  hideNotes,
  foodId,
  utilityId,
  healId,
  utility1Id,
  utility2Id,
  utility3Id,
  eliteId,
  weapon1MainId,
  weapon1MainSigil1Id,
  weapon1MainSigil2Id,
  weapon1MainType,
  weapon1MainAffix,
  weapon1MainSigil1,
  weapon1MainSigil2,
  weapon1MainInfusion1Id,
  weapon1MainInfusion2Id,
  weapon1OffId,
  weapon1OffSigilId,
  weapon1OffType,
  weapon1OffAffix,
  weapon1OffSigil,
  weapon1OffInfusionId,
  weapon2MainId,
  weapon2MainSigil1Id,
  weapon2MainSigil2Id,
  weapon2MainType,
  weapon2MainAffix,
  weapon2MainSigil1,
  weapon2MainSigil2,
  weapon2MainInfusion1Id,
  weapon2MainInfusion2Id,
  weapon2OffId,
  weapon2OffSigilId,
  weapon2OffType,
  weapon2OffAffix,
  weapon2OffSigil,
  weapon2OffInfusionId,
  legend1Id,
  legend2Id,
  children,
}) {
  const { classes } = useStyles()
  const [thisBossDpsStatistics, setThisBossDpsStatistics] = useState('')
  const errorMsg = (
    <div className={classes.errorMsgWrap}>
      <Error />
      <span className={classes.errorMsg}>No data available</span>
    </div>
  )
  const specialization = useContext(Context)

  const thisBoss = BOSSES.filter(
    (item) => item.name.toLowerCase() === name.toLowerCase(),
  )

  useEffect(() => {
    if (!specialization) {
      setThisBossDpsStatistics(null)
    }
    const abortfetch = new AbortController()
    axios
      .get(
        `https://gw2wingman.nevermindcreations.de/api/boss?bossID=${thisBoss[0].id}&era=this`,
        { signal: abortfetch },
      )
      .then((res) => {
        const professionsAverage = Object.entries(res.data.professions_avg)
        const professionMedian = Object.entries(res.data.professions_med)
        const professionTop = Object.entries(res.data.professions_top)
        const statistics = professionsAverage.concat(
          professionMedian,
          professionTop,
        )
        const thisClassStatistics = statistics.filter(
          (items) => items[0].toLowerCase() === specialization.toLowerCase(),
        )
        thisClassStatistics.forEach((item) => item.shift())
        const thisBuildData = [
          {
            text: 'Average',
            dps: thisClassStatistics[0] ? thisClassStatistics[0] : errorMsg,
          },
          {
            text: 'Median',
            dps: thisClassStatistics[1] ? thisClassStatistics[1] : errorMsg,
          },
          {
            text: 'Top',
            dps: thisClassStatistics[2] ? thisClassStatistics[2] : errorMsg,
          },
        ]
        const HealBuildData = [
          {
            text: 'Average',
            dps: errorMsg,
          },
          {
            text: 'Median',
            dps: errorMsg,
          },
          {
            text: 'Top',
            dps: errorMsg,
          },
        ]
        setThisBossDpsStatistics(
          foodId === '68634' ? HealBuildData : thisBuildData,
        )
      })
      .catch(() => {})

    return () => {
      abortfetch.abort()
    }
  }, [])

  const { hp, Image } = BOSSES.find(
    (b) => b.name.toUpperCase() === name.toUpperCase(),
  )
  const ref = name.toLowerCase().replace(' ', '')
  const showWeapons =
    weapon1MainId || weapon1OffId || weapon2MainId || weapon2OffId
  const showSkills = healId || utility1Id || utility2Id || utility3Id || eliteId
  const showLegends = legend1Id && legend2Id

  // leave this, might need it
  // eslint-disable-next-line no-unused-vars
  const sidebarNotes = !hideNotes && !showSkills && !showWeapons && !showLegends

  return (
    <>
      <EmbossedCard>
        <Link id={ref} to={`#${ref}`} style={{ textDecoration: 'none' }}>
          <Typography variant="h4">
            {name.toUpperCase()} <Label>{hp} HP</Label>{' '}
            {foodId && <Item id={foodId} disableText size="medium2" />}
            {utilityId && <Item id={utilityId} disableText size="medium2" />}
          </Typography>
        </Link>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
        >
          <Grid item xs={12} sm={6} style={{ marginBottom: 8 }}>
            {video && (
              <Embed
                youtube={video}
                Image={Image}
                className={classes.video}
                caption={`by ${videoCreator}`}
                timestamp={timestamp}
              />
            )}
            {!video && Image ? (
              <div className={classes.image}>
                <Image />
              </div>
            ) : null}
          </Grid>

          {specialization && (
            <Grid item xs={12} sm={6} className={classes.card}>
              <Typography variant="h6">
                DPS Statistics <Label>by gw2wingman</Label>
              </Typography>

              <Table>
                <TableBody>
                  {thisBossDpsStatistics ? (
                    thisBossDpsStatistics.map((item) => (
                      <TableRow className={classes.row} key={item.dps}>
                        <TableCell>
                          <Typography variant="body1">
                            {item.text && item.text}
                          </Typography>
                        </TableCell>
                        <TableCell>{item.dps && item.dps}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow className={classes.row}>
                      <TableCell>
                        <Progress />
                      </TableCell>
                      <TableCell>
                        <Progress />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Grid>
          )}
          {showWeapons && (
            <Grid item xs={12} sm={6} className={classes.card}>
              <EmbossedCard title="Weapons">
                <Box display="flex" className={classes.weaponWrapper}>
                  <Weapons
                    unembossed
                    weapon1MainId={weapon1MainId}
                    weapon1OffId={weapon1OffId}
                    weapon1MainSigil1={weapon1MainSigil1}
                    weapon1MainSigil2={weapon1MainSigil2}
                    weapon1MainSigil1Id={weapon1MainSigil1Id}
                    weapon1MainSigil2Id={weapon1MainSigil2Id}
                    weapon1MainAffix={weapon1MainAffix}
                    weapon1OffAffix={weapon1OffAffix}
                    weapon1OffSigil={weapon1OffSigil}
                    weapon1OffSigilId={weapon1OffSigilId}
                    weapon1MainType={weapon1MainType}
                    weapon1OffType={weapon1OffType}
                    weapon1MainInfusion1Id={weapon1MainInfusion1Id}
                    weapon1MainInfusion2Id={weapon1MainInfusion2Id}
                    weapon1OffInfusionId={weapon1OffInfusionId}
                    weapon2MainId={weapon2MainId}
                    weapon2OffId={weapon2OffId}
                    weapon2MainAffix={weapon2MainAffix}
                    weapon2OffAffix={weapon2OffAffix}
                    weapon2MainSigil1={weapon2MainSigil1}
                    weapon2MainSigil2={weapon2MainSigil2}
                    weapon2MainSigil1Id={weapon2MainSigil1Id}
                    weapon2MainSigil2Id={weapon2MainSigil2Id}
                    weapon2OffSigil={weapon2OffSigil}
                    weapon2OffSigilId={weapon2OffSigilId}
                    weapon2MainType={weapon2MainType}
                    weapon2OffType={weapon2OffType}
                    weapon2MainInfusion1Id={weapon2MainInfusion1Id}
                    weapon2MainInfusion2Id={weapon2MainInfusion2Id}
                    weapon2OffInfusionId={weapon2OffInfusionId}
                  />
                </Box>
              </EmbossedCard>
            </Grid>
          )}
          {showSkills && (
            <Grid item xs={12} sm={6} className={classes.card}>
              <EmbossedCard title="Skills">
                <Skills
                  unembossed
                  healId={healId}
                  utility1Id={utility1Id}
                  utility2Id={utility2Id}
                  utility3Id={utility3Id}
                  eliteId={eliteId}
                />
              </EmbossedCard>

              {showLegends && (
                <>
                  <Typography variant="h6">Legends:</Typography>
                  <Legends legend1Id={legend1Id} legend2Id={legend2Id} />
                </>
              )}
            </Grid>
          )}

          {sidebarNotes && (
            <Grid item xs={12} sm={6} className={classes.card}>
              <TextDivider text="Notes" />
              {children}
            </Grid>
          )}
          {!hideNotes && !sidebarNotes && (
            <Grid item xs={12}>
              <TextDivider text="Notes" />
              {children}
            </Grid>
          )}
        </Grid>
      </EmbossedCard>
      {!hideRotation && <TextDivider>Skill usage</TextDivider>}
    </>
  )
}

Boss.propTypes = {
  name: PropTypes.string.isRequired,
  video: PropTypes.string,
}

export default Boss
